import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import {
  IGetMonitoringRequest,
  IMonitoredEntity,
  IMonitoringApi,
  IGetMonitoringTransfersResponse,
  IMonitoringTreasury,
  IGetMonitoringChainDataResponse,
  IGetMonitoringAlertHistoryResponse,
  IGetPaginatedMonitoringRequest,
  IGetPaginatedMonitoringResponse,
} from '@/api/monitoring/monitoring.types';

export class MonitoringApi implements IMonitoringApi {
  private getBaseUrl(): string {
    return ApiEndpoints.MONITORING;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getMonitoring({ entityType, allExtreme, isBetaData }: IGetMonitoringRequest) {
    const params = {
      entityTypes: entityType,
      allExtreme: allExtreme,
      ...(isBetaData ? { isBetaData: isBetaData } : {}),
    };

    return this.httpClient.get<IMonitoredEntity[]>(this.getBaseUrl(), { params });
  }

  getPaginatedMonitoring({
    entityTypes,
    allExtreme,
    isBetaData,
    sortOrder,
    displayName,
    sortBy,
    page,
    size,
  }: IGetPaginatedMonitoringRequest) {
    const params = {
      ...(!!allExtreme ? { allExtreme } : {}),
      ...(!!displayName ? { displayName } : {}),
      ...(!!entityTypes ? { entityTypes } : {}),
      ...(!!isBetaData ? { isBetaData } : {}),
      ...(!!sortBy ? { sortBy } : {}),
      ...(!!sortOrder ? { sortOrder } : {}),
      page: page,
      size: size,
    };

    return this.httpClient.get<IGetPaginatedMonitoringResponse>(`${this.getBaseUrl()}entities/`, {
      params,
    });
  }

  getMonitoringTransfers(entityId: string) {
    return this.httpClient.get<IGetMonitoringTransfersResponse>(
      `${this.getBaseUrl()}${entityId}/transfers/`,
    );
  }

  getMonitoringTreasury(entityId: string) {
    return this.httpClient.get<IMonitoringTreasury[]>(`${this.getBaseUrl()}${entityId}/treasury/`);
  }

  getMonitoringChainData(agioId: string, isBetaData?: boolean) {
    const params = {
      ...(isBetaData ? { isBetaData: isBetaData } : {}),
    };
    return this.httpClient.get<IGetMonitoringChainDataResponse>(
      `${this.getBaseUrl()}${agioId}/chain_data/`,
      { params },
    );
  }

  getMonitoringAlertHistory(agioId: string, isBetaData?: boolean) {
    const params = {
      ...(isBetaData ? { isBetaData: isBetaData } : {}),
    };
    return this.httpClient.get<IGetMonitoringAlertHistoryResponse>(
      `${this.getBaseUrl()}${agioId}/alert_history/`,
      { params },
    );
  }
}
